var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocumentCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 27,
    height: 27,
    rx: 13.5,
    stroke: "#825DFC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6667 19.5H10.3333C9.59695 19.5 9 18.8844 9 18.125L9.00005 9.875C9.00006 9.11561 9.59701 8.5 10.3334 8.5H16.3335C17.0699 8.5 17.6669 9.11561 17.6669 9.875V12.625M18.3333 18.4688L19 19.1563M11.3335 11.25H15.3335M11.3335 13.3125H15.3335M11.3335 15.375H13.3335M18.6667 17.0938C18.6667 18.043 17.9205 18.8125 17 18.8125C16.0795 18.8125 15.3333 18.043 15.3333 17.0938C15.3333 16.1445 16.0795 15.375 17 15.375C17.9205 15.375 18.6667 16.1445 18.6667 17.0938Z",
    stroke: "#825DFC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentCircle);
export default __webpack_public_path__ + "static/media/document-circle.a8138f3f2b00a57c5f2e56cb74bfea4e.svg";
export { ForwardRef as ReactComponent };